export class LeadShortModel {

    public id: number;
    public firstName: string;
    public lastName: string;
    public phone: string;
    public email: string;
    public country: number;
    public registrationDate: string;
    public source: string;

    constructor(obj?: any) {
        this.id                 = obj && obj.id                 || null;
        this.firstName          = obj && obj.firstName          || '';
        this.lastName           = obj && obj.lastName           || '';
        this.phone              = obj && obj.phone              || '';
        this.email              = obj && obj.email              || '';
        this.country            = obj && obj.country            || '';
        this.registrationDate   = obj && obj.registrationDate   || '';
        this.source             = obj && obj.source             || '';
    }
}



// WEBPACK FOOTER //
// ./src/app/models/lead.short.model.ts